import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './i18n/inspirationalTemplateMap.en';
import { INSPIRATIONAL_TEMPLATE_MAP as ES_MAP } from './i18n/inspirationalTemplateMap.es';
import { INSPIRATIONAL_TEMPLATE_MAP as FR_MAP } from './i18n/inspirationalTemplateMap.fr';
import { INSPIRATIONAL_TEMPLATE_MAP as DE_MAP } from './i18n/inspirationalTemplateMap.de';
import { INSPIRATIONAL_TEMPLATE_MAP as JA_MAP } from './i18n/inspirationalTemplateMap.ja';
import { INSPIRATIONAL_TEMPLATE_MAP as PT_MAP } from './i18n/inspirationalTemplateMap.pt';
import { AdditionalFields } from './domain/entities/inspirationalTemplate';

export enum CategorySlug {
  DEFAULT = 'all-templates',
  DESIGNED_TEMPLATES = 'designed-templates',
  INSPIRATIONAL = 'inspirational',
  WIREFRAMES = 'wireframes',
  ECOMMERCE = 'ecommerce',
  ONE_PAGE = 'one-page',
  PORTFOLIO_TYPE = 'type-portfolio',
  COMPANY_SITE = 'company-site',
  CMS = 'cms',
  BUSINESS = 'business',
  TECHNOLOGY = 'technology',
  CREATIVE = 'creative',
  FASHION_BEAUTY = 'fashion-beauty',
  STORES = 'stores',
  BOOKINGS = 'bookings',
  PORTFOLIO_FEATURE = 'feature-portfolio',
  BLOG = 'blog',
  EVENTS = 'events',
  PRICING_PLANS = 'pricing-plans',
  RESTAURANTS = 'restaurants',
  DARK = 'dark',
  MINIMAL = 'minimal',
  ILLUSTRATIVE = 'illustrative',
  TYPOGRAPHY = 'typography',
}

export const isCategorySlug = (slug: string): slug is CategorySlug =>
  Object.values(CategorySlug).includes(slug as CategorySlug);

export const BLANK_TEMPLATE_META_SITE_ID =
  'fe86a14e-ef67-49b4-a409-d086f3abaa1a';
export const EDIT_TEMPLATE_URL = 'https://editor.wix.com/edit-template/from';
export const SITELESS_EDIT_TEMPLATE_URL =
  'https://editor.wix.com/edit-template/from-intro-siteless';
export const SOCIAL_MEDIA_THUMBNAIL_URL =
  'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/social-media/wix_studio_social_thumbnail_1200X628.jpg';
export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'fr',
  'de',
  'ja',
  'pt',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const isSupportedLanguage = (lang: string): lang is SupportedLanguage =>
  SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);

export const INSPIRATIONAL_CATEGORY_SLUG = 'inspirational';

export const INSPIRATIONAL_TEMPLATES_LANGUAGE_MAP: Record<
  SupportedLanguage,
  Record<string, AdditionalFields>
> = {
  de: DE_MAP,
  es: ES_MAP,
  fr: FR_MAP,
  ja: JA_MAP,
  pt: PT_MAP,
  en: EN_MAP,
};

interface CategoryGroupConfig {
  title: string;
  categorySlugs: string[];
}

export const TOP_BAR_CATEGORY_GROUPS: CategoryGroupConfig[] = [
  {
    title: 'app.topBar.menu.buckets.main',
    categorySlugs: [
      CategorySlug.DEFAULT,
      CategorySlug.WIREFRAMES,
      CategorySlug.DESIGNED_TEMPLATES,
      CategorySlug.INSPIRATIONAL,
    ],
  },
  {
    title: 'app.topBar.menu.buckets.type',
    categorySlugs: [
      CategorySlug.ONE_PAGE,
      CategorySlug.ECOMMERCE,
      CategorySlug.PORTFOLIO_TYPE,
      CategorySlug.COMPANY_SITE,
      CategorySlug.CMS,
    ],
  },
  {
    title: 'app.topBar.menu.buckets.industry',
    categorySlugs: [
      CategorySlug.BUSINESS,
      CategorySlug.TECHNOLOGY,
      CategorySlug.CREATIVE,
      CategorySlug.FASHION_BEAUTY,
    ],
  },
  {
    title: 'app.topBar.menu.buckets.features',
    categorySlugs: [
      CategorySlug.STORES,
      CategorySlug.BOOKINGS,
      CategorySlug.PORTFOLIO_FEATURE,
      CategorySlug.BLOG,
      CategorySlug.EVENTS,
      CategorySlug.PRICING_PLANS,
      CategorySlug.RESTAURANTS,
    ],
  },
  {
    title: 'app.topBar.menu.buckets.style',
    categorySlugs: [
      CategorySlug.DARK,
      CategorySlug.MINIMAL,
      CategorySlug.ILLUSTRATIVE,
      CategorySlug.TYPOGRAPHY,
    ],
  },
];

export const SIDE_PANEL_CATEGORY_GROUPS: CategoryGroupConfig[] = [
  {
    title: 'app.new.bucket.category',
    categorySlugs: [
      CategorySlug.DEFAULT,
      CategorySlug.DESIGNED_TEMPLATES,
      CategorySlug.WIREFRAMES,
      CategorySlug.INSPIRATIONAL,
    ],
  },
  {
    title: 'app.new.bucket.type',
    categorySlugs: [
      CategorySlug.ECOMMERCE,
      CategorySlug.PORTFOLIO_TYPE,
      CategorySlug.ONE_PAGE,
      CategorySlug.COMPANY_SITE,
      CategorySlug.CMS,
    ],
  },
  {
    title: 'app.new.bucket.industry',
    categorySlugs: [
      CategorySlug.BUSINESS,
      CategorySlug.TECHNOLOGY,
      CategorySlug.CREATIVE,
      CategorySlug.FASHION_BEAUTY,
    ],
  },
  {
    title: 'app.new.bucket.features',
    categorySlugs: [
      CategorySlug.STORES,
      CategorySlug.BOOKINGS,
      CategorySlug.PORTFOLIO_FEATURE,
      CategorySlug.BLOG,
      CategorySlug.EVENTS,
      CategorySlug.PRICING_PLANS,
      CategorySlug.RESTAURANTS,
    ],
  },
  {
    title: 'app.new.bucket.style',
    categorySlugs: [
      CategorySlug.DARK,
      CategorySlug.MINIMAL,
      CategorySlug.ILLUSTRATIVE,
      CategorySlug.TYPOGRAPHY,
    ],
  },
];
